<template>
  <v-container>
    <v-card flat color="transparent">
      <v-card-title class="white--text text-h5 font-weight-bold">Stellenanzeigen auf Webseite</v-card-title>
      <v-card-subtitle class="white--text pb-4"> Verwalte hier die Job-Angebote, die auf der Webseite angezeigt werden. </v-card-subtitle>

      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-card @click="openAddDialog" class="item-card text-center d-flex flex-column justify-center" min-height="220" hover>
            <v-icon size="60" color="primary">mdi-plus-box</v-icon>
            <v-card-title class="justify-center pt-3">Neue Anzeige</v-card-title>
          </v-card>
        </v-col>

        <v-col v-for="job in jobOffers" :key="job._id" cols="12" sm="6" md="4">
          <v-card @click="openEditDialog(job)" class="item-card text-center d-flex flex-column" min-height="220" hover>
            <div class="status-indicator" :class="job.visible ? 'is-visible' : 'is-hidden'">
              <v-icon small color="white">{{ job.visible ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
              <span class="ml-1">{{ job.visible ? "Sichtbar" : "Versteckt" }}</span>
            </div>

            <div class="item-card-icon-container">
              <v-icon size="50" color="primary">mdi-briefcase-outline</v-icon>
            </div>

            <v-card-title class="justify-center pt-3 pb-1">{{ job.title || job.type.title }}</v-card-title>
            <v-card-text class="white--text font-weight-light">
              {{ job.durationType || "Kein Anstellungstyp" }}
              <span v-if="job.durationTitle">| {{ job.durationTitle }}</span>
            </v-card-text>
            <v-card-subtitle class="caption"> Zuletzt bearbeitet: {{ formatDate(job.updatedAt) }} </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card dark>
        <v-card-title class="text-h5">{{ formTitle }}</v-card-title>
        <v-card-text class="pt-4">
          <v-select
            v-if="!editedItem._id"
            v-model="selectedJobType"
            :items="availableJobTypes"
            item-text="title"
            label="Job-Vorlage auswählen"
            return-object
            @change="initializeNewJobOffer"
            outlined
            class="mb-4"></v-select>

          <v-form v-if="editedItem.type">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedItem.title" label="Titel der Stellenanzeige" outlined></v-text-field>
                <v-checkbox v-model="editedItem.visible" label="Sichtbar auf der Webseite"></v-checkbox>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editedItem.durationType"
                  :items="['Festanstellung', 'Teilzeit', 'Lehrstelle', 'Praktikum', 'Ausbildung']"
                  label="Anstellungstyp"
                  outlined></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.durationTitle"
                  label="Prozente (z.B. 50% - 60%)"
                  :rules="[percentValidation]"
                  outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider class="my-3"></v-divider>
                <v-checkbox v-model="editedItem.useCustomContact" label="Benutzerdefinierte Kontaktperson verwenden"></v-checkbox>
              </v-col>

              <template v-if="editedItem.useCustomContact">
                <v-col cols="12" md="6"><v-text-field v-model="editedItem.contactInfo.firstName" label="Vorname" outlined></v-text-field></v-col>
                <v-col cols="12" md="6"><v-text-field v-model="editedItem.contactInfo.lastName" label="Nachname" outlined></v-text-field></v-col>
                <v-col cols="12" md="6"><v-text-field v-model="editedItem.contactInfo.email" label="E-Mail" outlined></v-text-field></v-col>
                <v-col cols="12" md="6"><v-text-field v-model="editedItem.contactInfo.phone" label="Telefon" outlined></v-text-field></v-col>
              </template>
              <template v-else>
                <v-col cols="12" md="6"
                  ><v-text-field :value="editedItem.type.contactInfo.firstName" label="Vorname" readonly outlined></v-text-field
                ></v-col>
                <v-col cols="12" md="6"
                  ><v-text-field :value="editedItem.type.contactInfo.lastName" label="Nachname" readonly outlined></v-text-field
                ></v-col>
                <v-col cols="12" md="6"
                  ><v-text-field :value="editedItem.type.contactInfo.email" label="E-Mail" readonly outlined></v-text-field
                ></v-col>
                <v-col cols="12" md="6"
                  ><v-text-field :value="editedItem.type.contactInfo.phone" label="Telefon" readonly outlined></v-text-field
                ></v-col>
              </template>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Abbrechen</v-btn>
          <v-btn color="primary" @click="saveJobOffer" :disabled="!isJobOfferValid" :loading="isSaving">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "@/api"

export default {
  data() {
    return {
      jobOffers: [],
      availableJobTypes: [],
      selectedJobType: null,
      dialog: false,
      isSaving: false,
      editedItem: {},
      defaultItem: {
        _id: null,
        type: null,
        title: "",
        visible: false,
        durationType: "",
        durationTitle: "",
        useCustomContact: false,
        contactInfo: { firstName: "", lastName: "", email: "", phone: "" },
        updatedAt: new Date().toISOString(),
      },
      percentValidation: (value) => {
        if (!value) return true // Leere Eingabe ist gültig
        const regex = /^(\d{1,3}%|\d{1,3}%\s*-\s*\d{1,3}%)$/
        return regex.test(value) || 'Format: "50%" oder "50% - 60%"'
      },
    }
  },
  computed: {
    formTitle() {
      return this.editedItem._id ? "Stellenanzeige bearbeiten" : "Neue Stellenanzeige erstellen"
    },
    isJobOfferValid() {
      if (!this.editedItem.type) return false
      const regex = /^(\d{1,3}%|\d{1,3}%\s*-\s*\d{1,3}%)$/
      return regex.test(this.editedItem.durationTitle) || this.editedItem.durationTitle === ""
    },
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      try {
        this.jobOffers = await api.fetchJobOffers()
        this.availableJobTypes = await api.fetchJobTypes()
      } catch (error) {
        this.$toast.error("Fehler beim Laden der Daten")
      }
    },
    openAddDialog() {
      this.selectedJobType = null
      this.editedItem = { ...this.defaultItem }
      this.dialog = true
    },
    openEditDialog(item) {
      this.editedItem = JSON.parse(JSON.stringify(item)) // Tiefe Kopie, um Original nicht zu verändern
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    initializeNewJobOffer() {
      if (this.selectedJobType) {
        this.editedItem = {
          ...this.defaultItem,
          type: this.selectedJobType,
          title: this.selectedJobType.title,
        }
      }
    },
    async saveJobOffer() {
      if (!this.isJobOfferValid) return
      this.isSaving = true

      const payload = {
        type: this.editedItem.type._id,
        title: this.editedItem.title,
        visible: this.editedItem.visible,
        durationType: this.editedItem.durationType,
        durationTitle: this.editedItem.durationTitle,
        useCustomContact: this.editedItem.useCustomContact,
        contactInfo: this.editedItem.useCustomContact ? this.editedItem.contactInfo : { firstName: "", lastName: "", email: "", phone: "" },
      }

      try {
        if (this.editedItem._id) {
          await api.updateJobOffer(this.editedItem._id, payload)
        } else {
          await api.createJobOffer(payload)
        }
        this.$toast.success("Job-Anzeige erfolgreich gespeichert")
        this.closeDialog()
        this.init() // Daten neu laden, um die Liste zu aktualisieren
      } catch (error) {
        this.$toast.error("Fehler beim Speichern der Job-Anzeige")
      } finally {
        this.isSaving = false
      }
    },
    formatDate(date) {
      return this.$moment(date).format("DD.MM.YY HH:mm") + " Uhr"
    },
  },
}
</script>

<style scoped>
.item-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 12px !important;
  background: linear-gradient(145deg, #2a2a2a, #1e1e1e);
  box-shadow: 5px 5px 15px #1c1c1c, -5px -5px 15px #2e2e2e;
  border: 2px solid transparent;
  position: relative;
  height: 100%;
}

.item-card:hover {
  transform: translateY(-5px);
  border-color: var(--v-primary-base);
}

.item-card-icon-container {
  padding-top: 24px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  color: white;
  display: flex;
  align-items: center;
}

.status-indicator.is-visible {
  background-color: #4caf50; /* Grün */
}

.status-indicator.is-hidden {
  background-color: #f44336; /* Rot */
}
</style>
